
import { Form } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { CompanyLogoUploader } from "./CompanyLogoUploader";
import { CompanyFormFields } from "./CompanyFormFields";
import { useCompanyForm } from "./useCompanyForm";

export function CompanyInfoForm() {
  const { form, isLoading, logoUrl, handleLogoChange, onSubmit, companyInitials } = useCompanyForm();

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
        <div className="flex items-center gap-6">
          <CompanyLogoUploader 
            logoUrl={logoUrl} 
            companyInitials={companyInitials}
            handleLogoChange={handleLogoChange}
            isLoading={isLoading}
          />
        </div>

        <CompanyFormFields form={form} isLoading={isLoading} />
        
        <Button 
          type="submit"
          className="bg-brand-teal hover:bg-brand-teal/90"
          disabled={isLoading}
        >
          {isLoading ? "Salvando..." : "Salvar Alterações"}
        </Button>
      </form>
    </Form>
  );
}
